import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    url: String,
    interval: Number
  }

  connect() {
    this.refreshInterval = setInterval(this._refreshTurboFrame.bind(this), this.intervalValue);
    window.addEventListener('turbo:refresh-all-frames', this._refreshTurboFrame.bind(this));
  }

  disconnect() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
    window.removeEventListener('turbo:refresh-all-frames', this._refreshTurboFrame.bind(this));
  }

  _refreshTurboFrame() {
    const url = new URL(this.urlValue, window.location.origin);
    if (window._juno_access_token) {
      url.searchParams.set('juno_access_token', window._juno_access_token);
    }
    Turbo.visit(url.toString(), { frame: this.element.id });
  }
}
